import { render, staticRenderFns } from "./OrgDemandsList.vue?vue&type=template&id=f4c92cae&scoped=true&"
import script from "./OrgDemandsList.vue?vue&type=script&lang=js&"
export * from "./OrgDemandsList.vue?vue&type=script&lang=js&"
import style0 from "./OrgDemandsList.vue?vue&type=style&index=0&id=f4c92cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c92cae",
  null
  
)

export default component.exports